import * as store from '@/store';

import {feLogger} from './index';

enum RepType {
    Click = 'click',
    Show = 'show',
}

/**
 * 模板库相关埋点
 */
const LogIdMap = {
    clickEntry: '80001.2.269', // 点击入口
    showMaterialPanel: '80001.2.270', // 模板库打开次数
    clickCopy: '80001.2.271', // 点击复制
    clickViewOrigin: '80001.2.272', // 点击访问原始文档
    clickTop: '80001.2.273', // 点击置顶/取消置顶
    clickAddMaterial: '80001.2.274', // 点击保存为模板
    clickAddMaterialToast: '80001.2.285', // 点击保存模板 toast 提示
    clickTag: '80001.2.286', // 点击标签
    clickInsert: '80001.2.268', // 点击插入模板
};

const report = (reportId: string, data: any = {}, rep_type = RepType.Click) => {
    feLogger({
        rep_id: reportId,
        rep_type,
        rep_params: {...data},
    });
};


export const reportClickMaterialEntry = (data: {
    position: 'entry' | 'tab';
    docId: string;
}) => {
    report(LogIdMap.clickEntry, data);
};

export const reportShowMaterial = (data: {
    docId: string;
}) => {
    report(LogIdMap.showMaterialPanel, data, RepType.Show);
};

export const reportClickMaterialCopy = (data: {
    id: string;
    source: 'official' | 'mine' | 'recent';
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};
    report(LogIdMap.clickCopy, {
        ...data,
        docId: docGuid,
    });
};

export const reportClickViewOrigin = (data: {
    id: string;
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};
    report(LogIdMap.clickViewOrigin, {
        ...data,
        docId: docGuid,
    });
};

export const reportClickTop = (data: {
    id: string;
    action: 'top' | 'cancelTop';
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};
    report(LogIdMap.clickTop, {
        ...data,
        docId: docGuid,
    });
};


export const reportClickAddMaterial = (data: {
    docId: string;
}) => {
    report(LogIdMap.clickAddMaterial, data);
};

export const reportClickAddMaterialToast = (data: {
    position: 'entry' | 'toast';
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};

    report(LogIdMap.clickAddMaterialToast, {
        ...data,
        docId: docGuid,
    });
};

export const reportClickTag = (data: {
    tag: string;
    action: 'select' | 'unselect';
    type: 'new' | 'hot';
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};
    report(LogIdMap.clickTag, {
        ...data,
        docId: docGuid,
    });
};

export const reportClickInsert = (data: {
    id: string;
    name: string;
    source: string;
    action: string;
    docId: string;
    isNew: boolean;
    nodes: any;
}) => {
    report(LogIdMap.clickInsert, data);
};
